import LegalPage from '@/components/Legal/LegalPage';

export default function SubprocessorsRoute() {
  return <LegalPage docKey="subprocessors" />;
}
